import { AbilityBuilder } from "@casl/ability";
import { AppAbility, Role } from "./define-permissions";

export const siteContextPermissions = (
  builder: AbilityBuilder<AppAbility>,
  role: Role,
  userToken: string,
  userEmail: string,
  isLegacyAgreement: boolean,
  hasAccessToEVChargers: boolean,
) => {
  const { can, cannot } = builder;

  can("read", "Tenants");

  can("read", "TenantResources");

  can("read", "TenantBookingRules");

  can("read", "TenantsAdminInvitations");

  can("read", "ParkingSpots");

  can("read", "Statistics");

  can("read", "Sites");

  can("read", "SiteAdministrators");

  can("read", "BlackListedLicensePlate");

  can("read", "TermsAndConditions");
  can("read", "PrivacyPolicy");
  can("update", "Password");

  can("read", "SiteDetails");
  can("read", "ParkingDetails");

  can("read", "SiteRemoval");

  can("read", "SiteSecurityAdministrators");

  can("update", "NotificationsSettings");

  can("read", "Notifications");

  can("update", "Notifications");

  if (hasAccessToEVChargers) {
    can("read", "SiteChargingSpots");
    can("read", "SiteChargingUsageLimits");

    can("read", "TenantEvChargers");

    can("read", "SiteChargingRules");

    can("read", "SiteEvChargersElectricityUsage");
  }

  if (role === "admin" || role === "owner" || role === "master") {
    can("create", "Tenants");
    can("delete", "Tenants");
    can("update", "Tenants");

    can("create", "TenantsAdminInvitations");

    can("create", "ParkingSpots");
    can("update", "ParkingSpots");
    can("delete", "ParkingSpots");
    can("assign", "ParkingSpots");
    can("detach", "ParkingSpots");
    can("addMap", "ParkingSpots");
    can("setAsReserve", "ParkingSpots");
    can("deleteMap", "ParkingSpots");
    can("lockSpot", "ParkingSpots");
    can("unlockSpot", "ParkingSpots");

    can("create", "Sites");

    can("updatePhoneNumber", "SiteAdministrators", { userToken: { $eq: userToken } });
    can("resendInvitation", "SiteAdministrators", { userToken: { $ne: userToken } });

    can("resendInvitation", "SiteSecurityAdministrators", { userEmail: { $ne: userEmail } });

    can("create", "BlackListedLicensePlate");
    can("delete", "BlackListedLicensePlate");

    can("send", "Contact");

    can("update", "IntegrationQuestionnaire");

    if (hasAccessToEVChargers) {
      can("manageMap", "SiteChargingSpots");
      can("manageTenants", "SiteChargingSpots");
      can("pauseBooking", "SiteChargingSpots");
      can("unpauseBooking", "SiteChargingSpots");
      can("update", "SiteChargingSpots");

      can("manageLimit", "SiteChargingUsageLimits");

      can("assign", "TenantEvChargers");
      can("detach", "TenantEvChargers");

      can("update", "SiteChargingRules");
    }
  }

  if (role === "owner" || role === "master") {
    can("delete", "TenantsAdminInvitations");

    can("delete", "Sites");
    can("update", "Sites");
    can("manageLimits", "Sites");

    can("create", "SiteAdministrators");
    can("chooseRole", "SiteAdministrators");
    can("updatePhoneNumber", "SiteAdministrators");
    can("updateRole", "SiteAdministrators", { userToken: { $ne: userToken } });
    can("delete", "SiteAdministrators", { userToken: { $ne: userToken } });

    can("create", "SiteSecurityAdministrators");

    can("delete", "SiteSecurityAdministrators", { userEmail: { $ne: userEmail } });

    can("update", "SiteDetails");
    can("create", "ParkingDetails");

    can("cancel", "SiteRemoval");
    can("acceptOrReject", "SiteRemoval");

    can("read", "AllSitesBilling");
    can("requestIntegration", "AllSitesBilling");
    can("changeSpotsLimit", "AllSitesBilling");

    can("read", "BillingHistory");
    can("downloadInvoice", "BillingHistory");

    can("read", "BillingDetails");
    can("update", "BillingDetails");

    can("update", "NotificationsSettings");
  }

  if (role === "master") {
    can("read", "SystemMessages");
    can("create", "SystemMessages");
    can("update", "SystemMessages");
    can("delete", "SystemMessages");
  }

  if (isLegacyAgreement) {
    cannot("read", "AllSitesBilling");
    cannot("requestIntegration", "AllSitesBilling");
    cannot("changeSpotsLimit", "AllSitesBilling");

    cannot("read", "BillingHistory");
    cannot("downloadInvoice", "BillingHistory");

    cannot("read", "BillingDetails");
    cannot("update", "BillingDetails");
  }
};
